import { render, staticRenderFns } from "./DeleteContactModal.vue?vue&type=template&id=eee3aa08&lang=pug"
import script from "./DeleteContactModal.vue?vue&type=script&lang=js"
export * from "./DeleteContactModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports